module.exports = __webpack_public_path__ + "static/media/wall-turaanadaa.ee7e0ef5.png";